import "swiper/css";
import { useState } from "react";
import { DecisionCard } from "../DecisionCard";
import { DecisionPreview } from "../DecisionPreview";
import Modal from "../../Modal";
import { SDecisionList } from "../../../styles/StyledDecisionList";

type DecisionListProps = {
	data: any[];
	clearSearchResults: boolean;
};

const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		minWidth: "50rem",
		maxWidth: "50rem",
		padding: "25px",
		maxHeight: "70vh",
		overflow: "hidden" as const,
		background: "#F7F8F9",
		zIndex: 20,
	},
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		zIndex: 1000,
	},
};

export const DecisionList = (props: DecisionListProps) => {
	const { data, clearSearchResults } = props;

	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [modalId, setModalId] = useState(null);

	const openModal = (id: any) => {
		if (id !== modalId) setModalId(id);
		setModalIsOpen(true);
	};

	const closeModal = () => {
		setModalIsOpen(false);
	};

	return (
		<>
			<>
				{data.length > 0 ? (
					<SDecisionList>
						{data.map((decision) => {
							return (
								<DecisionCard
									key={decision.id}
									clearSearchResults={clearSearchResults}
									data={decision}
									decisionsList={data}
									openModal={openModal}
								/>
							);
						})}
					</SDecisionList>
				) : (
					"No decisions found"
				)}

				<Modal
					isOpen={modalIsOpen}
					onRequestClose={closeModal}
					style={customStyles}
					appElement={document.getElementById("app")!}
					role="overviewEdit-modal"
				>
					<DecisionPreview clearSearchResults={clearSearchResults} closeModal={closeModal} decisionId={modalId} decisionsList={data} />
				</Modal>
			</>
		</>
	);
};
